import apiClient from "./apiClient";
import { Brand, CreateBrandDto, UpdateBrandDto } from "../types/brand";

// Re-export types for barrel file
export type { Brand, CreateBrandDto, UpdateBrandDto };

/**
 * Detect brand from domain (public endpoint, no auth required)
 * Used by login page to display brand name
 */
export const detectBrandByDomain = async (
  domain: string
): Promise<Partial<Brand>> => {
  const { data } = await apiClient.get(
    `/brands/detect?domain=${encodeURIComponent(domain)}`
  );
  return data;
};

// Brand CRUD operations
export const getBrands = async (): Promise<Brand[]> => {
  const { data } = await apiClient.get("/brands");
  return data;
};

export const getBrand = async (brandId: string): Promise<Brand> => {
  const { data } = await apiClient.get(`/brands/${brandId}`);
  return data;
};

export const createBrand = async (
  brandData: CreateBrandDto
): Promise<Brand> => {
  const { data } = await apiClient.post("/brands", brandData);
  return data;
};

export const updateBrand = async (
  brandId: string,
  brandData: UpdateBrandDto
): Promise<Brand> => {
  const { data } = await apiClient.patch(`/brands/${brandId}`, brandData);
  return data;
};

export const deleteBrand = async (brandId: string): Promise<void> => {
  await apiClient.delete(`/brands/${brandId}`);
};

// Email config test-send (spec 2026-07-15-mail-delivery-test-and-status, F1)
export interface TestSendEmailConfigResult {
  ok: boolean;
  error?: string;
}

export const testSendBrandEmailConfig = async (
  brandId: string,
  targetEmail: string
): Promise<TestSendEmailConfigResult> => {
  const { data } = await apiClient.post(
    `/brands/${brandId}/email-config/test-send`,
    { targetEmail }
  );
  return data;
};

// Meta CAPI test-send — sends a synthetic CompleteRegistration with a
// test_event_code through the saved brand config (same path as production).
export interface TestSendMetaCapiResult {
  ok: boolean;
  eventsReceived?: number;
  fbtraceId?: string;
  error?: string;
  errorCode?: number;
}

export const testSendBrandMetaCapi = async (
  brandId: string,
  testEventCode: string
): Promise<TestSendMetaCapiResult> => {
  const { data } = await apiClient.post(
    `/brands/${brandId}/meta-capi/test-send`,
    { testEventCode }
  );
  return data;
};
